import { Bot, Sparkles } from 'lucide-react';

// Wave-3 hero placeholder. Looks live, says clearly it's coming. Conditions
// the muscle memory ("OneDesk is where I ask things") before the gateway lands.

const SUGGESTIONS = [
  "What's my leave balance?",
  'Who owns Graphite?',
  'Travel policy?',
  'How do I file an expense?',
  'Show me my SLA breakdown',
];

export const AiAskBar = () => (
  <section
    aria-label="Ask OneDesk"
    aria-disabled="true"
    className="shimmer relative overflow-hidden rounded-2xl border border-dashed border-line bg-bg-secondary/50 p-4 shadow-sm sm:p-5"
  >
    <span className="coming-soon-pulse absolute right-3 top-3 inline-flex items-center gap-1 rounded-full bg-brand-orange/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-brand-orange">
      <Sparkles className="h-3 w-3" /> Coming soon
    </span>
    <div className="flex items-start gap-3 opacity-60">
      <div className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-text-tertiary/20 text-text-tertiary">
        <Bot className="h-5 w-5" aria-hidden="true" />
      </div>
      <div className="min-w-0 flex-1">
        <h2 className="text-sm font-semibold text-text-secondary">Ask OneDesk anything</h2>
        <p className="mt-0.5 text-xs text-text-tertiary">
          One AI assistant for every Alpha Direct question — governed, audited, with PII protection built in.
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {SUGGESTIONS.map((s) => (
            <span
              key={s}
              className="cursor-not-allowed select-none rounded-full border border-line bg-bg-primary px-2.5 py-1 text-[11px] text-text-tertiary"
              title="Coming soon"
            >
              {s}
            </span>
          ))}
        </div>
      </div>
    </div>
  </section>
);
